import map from "lodash/map";
import React from "react";
import styles from "./floatSidebarMenuTabs.module.css";
import { Chip } from "UiKit";
export default function SidebarMenuTabs(props) {
    const handleTabClick = (key) => {
        if (key === props.tabKey) {
            props.onExpandedChanged && props.onExpandedChanged(!props.expandedMenu);
        }
        else {
            if (!props.expandedMenu)
                props.onExpandedChanged && props.onExpandedChanged(true);
            props.onChangeTab && props.onChangeTab(key);
        }
    };
    return (React.createElement("div", { className: styles.container }, map(props.tabs, item => (React.createElement(Chip, { onClick: () => {
            handleTabClick(item.key);
        }, styleType: item.key === props.tabKey ? "input-selected" : "input", isActive: item.key === props.tabKey, key: item.key, size: "md", tooltipMessage: item.title, className: styles.tab },
        React.createElement("span", { className: styles.text }, item.title))))));
}
SidebarMenuTabs.defaultProps = {
    bgColorDefault: "navbar-bg",
    bgColorActive: "navbar-bg-lighter",
    rotateTab: true
};
